import React from 'react';
import { Button, TextField } from '@material-ui/core';
import { Search, Close } from '@material-ui/icons';

//css
import StylesCss from './styles';
const useStyles = StylesCss();

export default ({
    searchField,
    handleChangeSearchFieldPedido,
    handleClickSearchField,
    searchStatus,
    label
}) => {
    const classes = useStyles();

    return (
        <div style={{ display: 'flex', width: '100%' }}>
            <TextField
                id="outlined-multiline-flexible"
                label={label}
                value={searchField}
                onChange={handleChangeSearchFieldPedido}
                variant="outlined"
            />
            <Button
                variant="contained"
                color="secondary"
                className={classes.button}
                onClick={handleClickSearchField}
            >
    {/* Essa abordagem é temporária, será melhorado na refatoração */}
                {searchStatus && searchField !== '' ? (
                    <Close />
                ) : (
                    <Search />
                )}
            </Button>
        </div>
    );
}  